export enum WORKFLOW_STATUS_COLOR_TYPES {
    APPROVED = '#e2efd9',
    ABANDONED = '#d9e2f3',
    DENIED = '#fcc0c0',
    DEFAULT = '#58B4F3',
    OBLIGATION = '#fef2cb'
}